import React, { useEffect, useState } from "react";
import { useNavigate, useParams, useLocation } from "react-router";
import qs from "qs";
import "./style.less";
import { List } from "../../../blocks/blog-home-list/List";
import { blogAxios } from "../../../utils/blogAxios";
import { getTagListParams } from "./getTagListParams";
import { BlogHomeAside } from "../../../blocks/blog-home-aside";
import { BlogHeader } from "../../../components/BlogHeader";

export const BlogTagPage = ({ articleList }) => {
  const { id } = useParams();
  const [tagInfo, setTagInfo] = useState();
  const [loading, setLoading] = useState(false);
  const { search } = useLocation();
  const [page, setPage] = useState(Number(new URLSearchParams(search).get("page")) || 1);
  const [blogList, setBlogList] = useState(articleList || []);
  const [total, setTotal] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    setLoading(true);
    const query = getTagListParams(id);

    const searchString = qs.stringify(query);

    const promise1 = blogAxios.get(`/articles?${searchString}`).then(({ data }) => {
      setBlogList(data);
    });
    const promise2 = blogAxios.get(`/articles/count?${searchString}`).then(({ data }) => {
      setTotal(data);
    });
    const promise3 = blogAxios.get(`/tags/${id}`).then(({ data }) => setTagInfo(data));

    Promise.all([promise1, promise2, promise3]).finally(() => setLoading(false));
  }, [id, setTagInfo]);

  return (
    <div className="blog-tag-page">
      <BlogHeader />
      <div className="tag-header">
        <div className="header-content">
          <section className="tag-article-navbar">
            <span className="item click-able" onClick={() => navigate("/blog")}>
              博客
            </span>
            /<span className="item">标签</span>/<span className="item">{tagInfo?.name || "--"}</span>
          </section>
          <div className="tag-name-container">
            <i className="icon authing-icon authing-biaoqian"></i>
            <h1 className="tag-name">#{tagInfo?.name || "--"}</h1>
            <span className="read-count">{total} 篇文章</span>
          </div>
        </div>
      </div>
      <div className="tag-content">
        <div className="blog-list-warp">
          <List
            {...{
              loading,
              setPage,
              blogList,
              page,
              total,
            }}
          />
        </div>
        <BlogHomeAside />
      </div>
    </div>
  );
};
